import { supabase } from "@/lib/supabase";
import { Application } from "@/types/startup";

export const handleApplicationAction = async (
  application: Application,
  status: string,
  onSuccess: () => void,
  onError: (error: string) => void
) => {
  try {
    console.log('Updating application status:', { applicationId: application.id, status });
    
    const { error } = await supabase
      .from('startup_applications')
      .update({ status })
      .eq('id', application.id);

    if (error) {
      console.error('Error updating application:', error);
      onError("Failed to update application status");
      return;
    }

    onSuccess();
  } catch (error) {
    console.error('Error in handleApplicationAction:', error);
    onError("An unexpected error occurred");
  }
};